import type { CSSProperties } from 'react';
import { StyleSheet } from 'react-native';
import mixins from '../../app/styles';

export const TOOLTIP_WIDTH = 300;

const styles = StyleSheet.create({
  tooltip: {
    position: 'fixed' as any,
    maxWidth: 300,
    padding: mixins().indent.i5,
    backgroundColor: mixins().color.black,
    zIndex: 9999999,
    top: 0,
    left: 0,
    transform: [{ translateX: '-50%' as any }],
  },
  tooltipText: {
    color: mixins().color.whiteText,
    fontSize: 14,
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
});

export const css = {
  wrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,
  outerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 1,
  } as CSSProperties,
};

export default styles;
